import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { getTimestamp } from '@legacyApp/client/modules/app/timeService';
import { TRANSACTIONS_SET } from '@legacyApp/client/store/transactions/transactions.constants';
import { epic } from '@legacyApp/client/modules/app/epicService';
import { TABLE_ID } from '../../transactions/constants/TableId';
import { vipActions } from '../../vip/store/vip.actions';
import { captchaActions } from './captcha.actions';

const checkCaptchaEpic = epic('checkCaptchaEpic', {
	actions: (ofType) => ofType(captchaActions.setToken().type),
	callback: ({ action }) => {
		if (action.payload) {
			return of(captchaActions.setLastCheckTimestamp(getTimestamp()));
		}
		return of(captchaActions.setLastCheckTimestamp(null));
	},
});

const bypassV2Epic = epic('bypassV2Epic', {
	actions: (ofType) => ofType(vipActions.statusUpdate().type, TRANSACTIONS_SET),
	callback: ({ store$ }) => {
		let bool = false;
		const deposits = store$.value.transactions[TABLE_ID.depositHistory].length;
		if (deposits) {
			const turnover = store$.value.vip.status;
			if (deposits > 5) {
				bool = true;
			}
			if (turnover && turnover > 2000 && deposits > 1) {
				bool = true;
			}
		}
		console.log('bypassV2Epic', store$.value.captcha.bypass, bool);
		if (bool === store$.value.captcha.bypass) {
			return of();
		}
		return of(captchaActions.setBypass(bool));
	},
});

const captchaEpic = combineEpics(checkCaptchaEpic, bypassV2Epic);

export default captchaEpic;
